import { Dialog } from "primereact/dialog";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Fetch, ILazyParams } from "../../shared/Fetch";

interface IProps {
    open: boolean,
    hideDialog: () => void,
    toast: any,
    setSelectedClients: (is: IClientList[]) => void,
    selectedClientList: IClientList[],
}

export interface IClientList {
    contact_Person_Id: number,
    contact_Person_Name: string,
    contact_Person_EmailID: string,
    cell_No: string,
    phone_No: string,
    vendor_Company_ID: number,
    vendor_Company_Name: string,
    major_Technology: string,
    city_ID: number,
    city_Name: string,
    state_ID: number,
    state_Name: string,
}

export const SelectClientforsendHotList = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IClientList[], loading: boolean });
    const [selectedClient, setSelectedClient] = useState<Array<IClientList>>([]);
    const [totalRecords, setTotalRecords] = useState(0);

    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'Contact_Person_Id',
        sortOrder: -1
    });

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<any>({
        defaultValues: {},
        shouldFocusError: false
    });

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Consultant_Bench_HotList/clientlist", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}`, props.toast);
        if (response) {
            const data: Array<IClientList> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    const getTableDataCount = async () => {
        const response = await Fetch("Consultant_Bench_HotList/count", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    useEffect(() => {
        if (lazyParams.rows) {
            getTableDataCount();
            loadTableData();
        }
        setSelectedClient([]);
    }, [lazyParams]);

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center mr-2">
            <h5 className="m-0">Select Client for send HotList</h5>
        </div>
    );

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSubmit = (data: any) => {
        if(selectedClient?.length>0){
            props.setSelectedClients(selectedClient);
        };
        onHide();
    }
    const onHide = () => {
        props.hideDialog();
    }

    useEffect(()=>{
        setSelectedClient(props.selectedClientList);
    },[props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Select Client for send HotList" modal className="p-fluid" onHide={onHide} maximizable>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    className="w-full"
                    resizableColumns
                    // columnResizeMode="expand"
                    showGridlines
                    ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
                    value={tableData.tableData} lazy dataKey="contact_Person_Id"
                    paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[lazyParams.rows]}
                    totalRecords={totalRecords} onPage={onPage}
                    onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                    emptyMessage="No Client Contact Person found."
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    // header={header}
                    loading={tableData.loading}
                    selectionMode={'checkbox'}
                    selection={selectedClient}
                    onSelectionChange={(e) => {
                        const value = e.value as IClientList[];
                        setSelectedClient(value);
                    }}
                >
                    <Column selectionMode="multiple" style={{maxWidth: "3rem"}} />
                    {/* <Column field="consultant_Name" header="S No." sortable /> */}
                    <Column field="contact_Person_Name" header="Contact person" style={{maxWidth: "18rem"}} />
                    <Column field="contact_Person_EmailID" header="Email" style={{maxWidth: "16rem"}} />
                    <Column field="cell_No" header="Cell No" />
                    <Column field="phone_No" header="Phone No" />
                    <Column field="vendor_Company_Name" header="Company Name" />
                    <Column field="major_Technology" header="Major Skills" />
                    <Column field="city_Name" header="City" />
                    <Column field="state_Name" header="State" style={{maxWidth: "4rem"}} />
                </DataTable>
                <div className="col-12 md:col-12 gap-4 mt-5 flex">
                    <Button className="field col md:col" label="SELECT" type="submit"></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}